// Vedors
import { Container } from "pixi.js";
import { gsap, TweenMax } from "gsap";
// Levels
import { LevelObject } from "shared/levels"
// Models;
import { Block } from "shared/model";
// Main Intstance
import { Main } from "screens/main";
// Config
import { DefaultConfig, DropProductConfig, LevelsConfig, ScoreConfig } from "shared/config";
import { CounterStorage } from "shared/storages";
import { FillBarService, LanguageService, LoaderService, ShuffleService, SoundService } from "shared/services";
import { EventBus } from "shared/emmiter";
import { MixHelper, TilesHelper, MapGraphicsHelper } from "shared/helpers";
import { Game } from "screens";
import { v4 as uuidv4 } from 'uuid';

export class DropTheElementMechanic extends Container {
    private drag: boolean;
    private score: number;
    private tilesContainer: PIXI.Container;
    private substrateContainer: PIXI.Container;
    private substateArray: any[] = [];
    private animationContainer: PIXI.Container;
    private backgroundSubstate: PIXI.Container;
    private linesSubstate: PIXI.Container;
    private clusters;
    private moves = [];
    private tilesMargin: number = 16;
    private tilesCreated: number = 0;
    private productLength: number;
    private productCounter: number = 0;
    private matrix: any;
    private concatedMatrix;
    private hintTimer;
    private needToCreateProduct;
    private tileHintTimer;
    private startForSpawn = [];
    private booleanMatrix;
    public level;
    private isGameEnd: boolean = false;
    public zIndex;
    private time = {
        start: null,
        end: null,
        difference: null
    };

    constructor(level) {
        super();
        this.level = level;
        this.init();
    }

    public init(): void {
        this.isGameEnd = false;
        this.interactive = true;
        this.tilesContainer = new PIXI.Container;
        this.substrateContainer = new PIXI.Container;
        this.animationContainer = new PIXI.Container;
        this.backgroundSubstate = new PIXI.Container;
        this.linesSubstate = new PIXI.Container;
        this.linesSubstate.zIndex = 200;
        this.backgroundSubstate.zIndex = 100;
        this.animationContainer.zIndex = 1100;
        this.animationContainer.name = 'animation_container'
        this.substrateContainer.zIndex = 500;
        this.tilesContainer.zIndex = 1000;
        this.zIndex = 500;
        this.on("pointerdown", this.onMouseDown);
        this.on("pointerup", this.onMouseUp);
        this.on("pointermove", this.onMouseMove);
        // this.on("pointerout", this.onMouseOut);
        this.productLength = LevelsConfig.levels[this.level.num].products.length;
        this.needToCreateProduct = LevelsConfig.levels[this.level.num].products.length + 1;
        this.matrix = LevelsConfig.levels[this.level.num].array;

        const isAnimCreated = LevelObject.animations.length > 0 ? true : false;

        this.score = 0;

        this.time = {
            start: null,
            end: null,
            difference: null
        };

        for (let i = 0; i < this.matrix.length; i++) {
            LevelObject.tiles[i] = [];
            LevelObject.helpersBlocks[i] = [];
            this.substateArray[i] = [];
            this.startForSpawn[i] = []
            for (let j = 0; j < this.matrix[i].matrix.length; j++) {
                let isHasProduct = false;
                LevelObject.tiles[i][j] = [];
                LevelObject.helpersBlocks[i][j] = [];
                this.substateArray[i][j] = [];

                if (!LevelObject.animations[j] && !isAnimCreated) {
                    LevelObject.animations[j] = [];
                }

                let firstTile;
                for (let d = 0; d < this.matrix[i].matrix[j].length; d++) {
                    let productLength = 0;
                    const isEmpty = this.matrix[i].matrix[d][j];
                    for (let f = 0; f < LevelsConfig.levels[this.level.num].products.length; f++) {
                        const product = LevelsConfig.levels[this.level.num].products[f];
                        if (isEmpty === 1 && j === product.i && d < product.j && product.j - d >= 1) {
                            isHasProduct = true;
                            productLength = product.j - d;
                            break;
                        } else {
                            isHasProduct = false;
                        }
                    }

                    // if (i === 0 && j < 3) {
                    //     isHasProduct = true;
                    // } else {
                    //     isHasProduct = false;
                    // }

                    const result = this.createTile(i, j, d, isHasProduct, 0, productLength);
                    const sprite = result.tile;
                    LevelObject.tiles[i][j].push(sprite);
                    this.substateArray[i][j].push(result.substate);
                    this.tilesContainer.addChild(sprite);

                    // if (sprite.alpha !== 0 || sprite.type === 0) {
                    //     const substrate = this.createSubstate(j, d);
                    //     this.substrateContainer.addChild(substrate);
                    // }

                    if (sprite.alpha !== 0 && !firstTile) {
                        firstTile = sprite;
                    }

                    if (!LevelObject.animations[j][d] && !isAnimCreated) {
                        const animation = this.createNewAnimation(sprite.x, sprite.y, sprite);
                        LevelObject.animations[j][d] = animation;
                        this.animationContainer.addChild(animation);
                    }

                    // AnimationUtil.createMoveTween(sprite);
                }

                if (firstTile) {
                    this.matrix[i].startY = firstTile.y;
                    this.startForSpawn[i][j] = firstTile.y;
                }
            }
        }

        this.time.start = new Date().getTime();

        CounterStorage.counter.text = `0/${this.productLength}`
        this.addChild(this.substrateContainer, this.tilesContainer, this.backgroundSubstate, this.linesSubstate);
        Main.instance.app.stage.addChild(this.animationContainer);
        this.createBooleanMatrix();
        // this.addBackgroud();
        this.sortContainerChildren(this);
        this.getAllChains(true, true, false);

        MapGraphicsHelper.addGraphics(this.getConcatedMatrix(true), this.backgroundSubstate, this.linesSubstate)

        EventBus.emmiter.removeAllListeners();

        EventBus.emmiter.on('reset_game', () => {
            this.removeAllListeners();
            this.score = 0;
            this.deleteAll();
            this.init();
        })

        EventBus.emmiter.on('game_end', () => {
            this.isGameEnd = true;
        })

    }

    public calcTime(): void {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const userLevels = user.levels;
        this.time.end = new Date().getTime();
        const start = this.time.start;
        const end = this.time.end;
        const totalSeconds = (end - start) / 1000;
        let difMinutes: any = Math.floor(totalSeconds / 60);
        difMinutes = difMinutes > 9 ? difMinutes : `${difMinutes}`;
        let difSeconds: any = Math.floor(totalSeconds - difMinutes * 60);
        difSeconds = difSeconds > 9 ? difSeconds : `${difSeconds}`;

        const dif = `${difMinutes}${LanguageService.getTranslation('loc_pixi_min')} ${difSeconds}${LanguageService.getTranslation('loc_pixi_sec')}`;

        for (const key in userLevels) {
            if (userLevels.hasOwnProperty(key) && Number.parseInt(key) === Number.parseInt(this.level.num)) {
                const element = userLevels[key];
                element.time = dif;
                // user.levels[key].time = dif;
                user.levels[key].time = Math.round(totalSeconds);
            }
        }

        localStorage.setItem('mbny_game_user', JSON.stringify(user));
    }

    private createNewAnimation(x, y, tile) {
        const destructSheet = LoaderService.getResource('destruct_tile').spritesheet;
        const destructAnimation: PIXI.AnimatedSprite = new PIXI.AnimatedSprite(destructSheet.animations['tile_explosion']);
        destructAnimation.x = x + tile.width / 2;
        destructAnimation.y = y + tile.height / 3;
        destructAnimation.name = 'destruct_anim';
        // destructAnimation.width = tile.width * 3;
        // destructAnimation.height = tile.height * 3;
        destructAnimation.alpha = 0;
        destructAnimation.loop = false;
        destructAnimation.animationSpeed = 0.5;
        return destructAnimation;
    }

    private deleteAll(): void {
        for (let i = 0; i < LevelObject.tiles.length; i++) {
            for (let j = 0; j < LevelObject.tiles[i].length; j++) {
                const tile = LevelObject.tiles[i][j];
                LevelObject.tiles[i].splice(j, 1);
            }
        }

        this.removeChild(this.tilesContainer);
    }

    private createSubstate(i, j): PIXI.Sprite {
        this.tilesCreated += 1;
        const sprite = new PIXI.Sprite(LoaderService.getResource('cell').texture);
        const coord = this.getCoordinateTile(i, j);
        sprite.width = LevelObject.tileWidth + this.tilesMargin - LevelObject.tilesMargin - 8;
        sprite.height = LevelObject.tileHeight + this.tilesMargin - LevelObject.tilesMargin - 8;
        sprite.x = coord.tileX - 4;
        sprite.y = coord.tileY - 4;

        if (this.tilesCreated % 2) {
            sprite.alpha = 0.55;
        } else {
            sprite.alpha = 0.7;
        }

        return sprite;
    }

    private createTile(i, j, d, isHasProduct: boolean = false, needToAdd = 0, productLength = 0): { tile: Block, substate: PIXI.Sprite } {
        const texture = TilesHelper.getNewTexture(LevelsConfig.levels[this.level.num].drop_chance);
        let sprite: Block;
        const substate = this.createSubstate(j, d);
        sprite = new Block(texture.texture);
        sprite.type = texture.type;
        const coord = this.getCoordinateTile(j, d);
        sprite.width = LevelObject.tileWidth - LevelObject.tilesMargin;
        sprite.height = LevelObject.tileHeight - LevelObject.tilesMargin;
        sprite.x = coord.tileX;
        sprite.y = coord.tileY;

        if (needToAdd > 0) {
            sprite.row = needToAdd - d - 1;
        } else {
            sprite.row = d;
        }

        sprite.col = j;
        sprite.mapNum = i;
        sprite.id = uuidv4();
        // sprite.stateMachine = new BlockStateMashine(sprite);
        sprite.shift = 0;
        sprite.originScale.x = sprite.scale.x;
        sprite.originScale.y = sprite.scale.y;

        if (isHasProduct) {
            sprite.type = 0;
            sprite.isProduct = true;
        }

        if (isHasProduct && productLength < 3 && productLength > 0) {
            sprite.visible = false;
        }

        if (isHasProduct && productLength === 1) {
            sprite.isLast = true;
        }

        if (isHasProduct && productLength === 3) {
            this.needToCreateProduct -= 1;
            sprite.texture = LoaderService.getSpritesheet('main_sprites').textures[`LipStick_${this.needToCreateProduct}.png`];
            sprite.height = sprite.height * LevelObject.productHeight + LevelObject.tilesMargin * 1.5;
            substate.alpha = 1;
            substate.height = sprite.height;
            sprite.alpha = 1;
        }

        if (needToAdd > 0) {
            if (this.booleanMatrix[sprite.row][sprite.col] === 0) {
                sprite.alpha = 0;
                substate.alpha = 0;
                sprite.isHidden = true;
            }

        } else if (this.matrix[i].matrix[sprite.row][sprite.col] === 0) {
            sprite.alpha = 0;
            substate.alpha = 0;
            sprite.isHidden = true;
        }
        substate.x = sprite.x - LevelObject.tilesMargin / 3.5;
        substate.y = sprite.y - LevelObject.tilesMargin / 3.5;
        this.substrateContainer.addChild(substate);
        return {
            tile: sprite,
            substate: substate
        };
    }

    protected getCoordinateTile(column, row) {
        var tileX = column * (LevelObject.tileWidth);
        var tileY = row * (LevelObject.tileHeight);
        // var tileX = LevelObject.x + column  * LevelObject.tileWidth;
        // var tileY = LevelObject.y + row * LevelObject.tileHeight;
        return { tileX: tileX, tileY: tileY };
    }

    private addBackgroud(): void {
        const block1 = new PIXI.Container();
        const graphic1 = new PIXI.Graphics();
        graphic1.beginFill(0x000000, 0.2);
        graphic1.lineStyle(4, 0xffffff, 0.35);
        graphic1.drawRect(-16, -16, this.width + LevelObject.tilesMargin + 8, this.height + LevelObject.tilesMargin + 8);
        graphic1.endFill();
        block1.addChild(graphic1);
        // const bg = new PIXI.Sprite(Main.instance.app.loader.resources.grid.texture);
        // bg.width = this.width;
        // bg.height = this.height;
        // bg.name = 'bg_grid'
        // bg.x = this.x;
        // bg.y = this.y;
        // bg.zIndex = 100;
        this.addChild(block1);
    }

    public callGetAllChaint(): void {
        this.getAllChains(false, false, true, false, true);
    }

    private async getAllChains(isStart: boolean, isAuto: boolean, isMoveProducts, isAfterDelete = false, isAfterSwap: boolean = false) {
        clearTimeout(this.hintTimer);
        this.scaleMoves(false);
        await this.clearShifts();

        if (this.isGameEnd) {
            return;
        }

        this.getConcatedMatrix();
        this.scaleMoves(false);

        if (!isAfterDelete) {
            this.findClusters();
        }

        if (this.clusters.length > 0 || isAfterDelete) {
            this.interactive = false;
            this.deleteChains(isStart, isMoveProducts);

            if (!isStart) {
                this.changeScore(isAuto);
            }
            return true;
        }

        if (this.clusters.length === 0 && !isStart) {
            await this.findMoves(false);
            await this.checkMoves();

            if (this.moves.length === 0) {
                Game.instance.toggleMixScreen(true);
            } else {

                for (let i = 0; i < this.moves.length; i++) {
                    const tile1 = this.moves[i].tile1;
                    const tile2 = this.moves[i].tile2;

                    if (tile1.type === 0 || tile2.type === 0
                        || tile1.isProduct || tile2.isProduct
                        || tile1.alpha === 0 || tile2.alpha === 0) {
                        this.moves.splice(i, 1);
                    }
                }

                if (this.moves.length === 0) {
                    Game.instance.toggleMixScreen(true);
                    return;
                }
                Game.instance.toggleMixScreen(false);
                clearTimeout(this.hintTimer);
                this.hintTimer = setTimeout(() => {
                    this.scaleMoves(true, 0);
                }, 7000)
            }
        }

        if (this.moves && this.moves.length > 0 && !isAfterSwap) {
            this.interactive = true;
        }
        return false;
    }

    private async clearShifts(): Promise<void> {
        const tiles = LevelObject.tiles;

        new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = 0; d < tiles[i][j].length; d++) {
                        const tile = tiles[i][j][d];

                        tile.shift = 0;

                        if (i === tiles.length - 1 && j === tiles[i].length - 1 && d === tiles[i][j].length - 1) {
                            res(null);
                        }
                    }
                }
            }
        })
    }

    private async checkMoves(): Promise<void> {
        const moves = this.moves;
        const matrix = this.getConcatedMatrix();

        if (!this.moves) {
            return;
        }

        for (let i = 0; i < moves.length; i++) {
            const tile1 = matrix[moves[i].column1][moves[i].row1];
            const tile2 = matrix[moves[i].column2][moves[i].row2];

            if (tile1 === 0 || tile2 === 0) {
                this.moves.splice(i, 1)
            }
        }
    }

    private findClusters(isNeedToRemove: boolean = true) {
        const grid = LevelObject.tiles;
        let result = [];
        let row: number = 0;
        let col: number = 0;
        let array = this.concatedMatrix;
        this.concatedMatrix = array;
        for (row = 0; row < array.length; row++) {
            result = result.concat(this.getHorizontalChains(array, row, isNeedToRemove));
        }

        for (col = 0; col < array.length; col++) {
            result = result.concat(this.getVerticalChains(array, col, isNeedToRemove));
        }

        if (result.length >= 3 && isNeedToRemove) {
            for (let i = 0; i < result.length; i++) {
                result[i].type = -1;
            }
        }

        this.clusters = result;
    }

    private createBooleanMatrix() {
        const array = [];
        for (let i = 0; i < LevelObject.rows; i++) {
            array[i] = [];
            for (let j = LevelObject.columns - 1; j >= 0; j--) {
                const tile = this.getTile(i, j);

                if (tile !== null) {
                    array[i].unshift(1);
                } else {
                    array[i].unshift(0);
                }

            }
        }
        this.booleanMatrix = array;
    }

    private getConcatedMatrix(isStart = false) {
        const array = [];
        for (let i = 0; i < LevelObject.rows; i++) {
            array[i] = [];
            for (let j = LevelObject.columns - 1; j >= 0; j--) {
                const tile = this.getTile(i, j);


                if (tile !== null) {
                    array[i].unshift(tile);
                    continue;
                }

                if (tile && tile.type !== 0 && !isStart) {
                    array[i].unshift(0);
                    continue
                }

                if (tile === null) {
                    array[i].unshift(0);
                    continue;
                }

            }
        }
        this.concatedMatrix = array;
        return array;
    }

    private deleteChains(isStart, isMoveProducts): void {
        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let shift = 0;
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = LevelObject.tiles[i][j][d];
                    if (tile.type === -1) {
                        shift += 1;
                        // LevelObject.tiles[i][j].splice(d, 1);
                        // this.tiles.removeChild(tile);
                    } else {
                        tiles[i][j][d].shift = shift;

                        if (isStart && tiles[i][j][d].type !== 0) {
                            tiles[i][j][d].row = tiles[i][j][d].row + shift;
                        }

                        if (!isStart) {
                            tiles[i][j][d].row = tiles[i][j][d].row + shift;
                        }

                        if (tiles[i][j][d].row >= 7) {
                            tiles[i][j][d].row = 6;
                        }

                        if (tiles[i][j][d].row <= -1) {
                            tiles[i][j][d].row = 0;
                        }
                    }
                }
            }
        }

        this.moveBlocks(isStart, isMoveProducts);
    }

    private moveBlocks(isStart: boolean, isMoveProducts): void {
        let needToAnim = [];
        let needToAnimSubstate = [];
        const tiles = LevelObject.tiles;

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let deletedTiles = 0;
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = tiles[i][j][d];
                    const substate = this.substateArray[i][j][d];

                    if (tile && tile.type === -1 && !isStart) {

                        if (!tile.isProduct) {
                            LevelObject.animations[j][d].alpha = 1;
                            LevelObject.animations[j][d].gotoAndPlay(0);
                        }

                        substate.destroy(false, true, true, true);
                        this.substrateContainer.removeChild(substate);
                        this.substateArray[i][j].splice(d, 1);
                        LevelObject.tiles[i][j].splice(d, 1);

                        tile.destroy(false, true, true, true);
                        this.tilesContainer.removeChild(tile);
                        deletedTiles += 1;
                        continue;
                    }

                    if (tile && tile.shift > 0) {
                        needToAnim.push(tile);
                        needToAnimSubstate.push(substate)
                    }
                }

                if (deletedTiles > 0) {
                    const result = this.createNewTiles(i, j, deletedTiles, isStart, isMoveProducts);
                    const newTiles = result.tiles;
                    const newSubstates = result.substates;
                    needToAnim = needToAnim.concat(newTiles);
                    needToAnimSubstate = needToAnimSubstate.concat(newSubstates);
                }
            }
        }


        if (isStart) {
            this.mixTiles(true);
            this.getAllChains(true, true, false);
        } else {
            this.animLower(needToAnim, needToAnimSubstate);
        }
    }

    private createNewTiles(atrI, j, deletedTiles, isStart, isMoveProducts): { tiles, substates } {
        // needToAdd: number, arrayI, isStart, isMoveProducts
        const array = [];
        const substates = [];
        let firstTile = LevelObject.tiles[atrI][j][0];
        let firstNotCreated = LevelObject.tiles[atrI][j][0];
        let isProductInArray = false;
        let productLength = 1;

        if (firstTile && firstTile.type === 0 && !isMoveProducts) {
            isProductInArray = true;
        }

        for (let i = 0; i < deletedTiles; i++) {
            firstTile = LevelObject.tiles[atrI][j][0];
            const result = this.createTile(atrI, j, i, false, deletedTiles);
            const sprite = result.tile;
            const substate = result.substate;
            sprite.alpha = 0;
            sprite.isNew = true;

            if (firstTile) {
                sprite.y = firstTile.y - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = firstTile.shift;
            } else {
                sprite.y = 0 - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = 0;
            }

            if (firstNotCreated && firstNotCreated.shift === 0 && deletedTiles === 1) {
                sprite.y = 0 - (sprite.height + LevelObject.tilesMargin);
                sprite.shift = 1;
            }

            if (firstNotCreated && firstNotCreated.shift === 0 && deletedTiles > 1) {
                sprite.shift = deletedTiles;
                sprite.y = 0 - ((sprite.height + LevelObject.tilesMargin) * (i + 1))
            }

            if (isProductInArray) {
                sprite.shift = sprite.shift + 3;
                sprite.y = 0 - ((sprite.height + LevelObject.tilesMargin) * productLength);
                LevelObject.tiles[atrI][j].splice(3, 0, sprite)
                sprite.row = 3 + productLength - 1;
                productLength += 1;
            } else {
                LevelObject.tiles[atrI][j].unshift(sprite)
            }

            if (!firstNotCreated) {
                sprite.shift = deletedTiles;
                sprite.renderable = true;
            }

            substate.y = sprite.y;
            substate.alpha = 0;
            array.unshift(sprite);
            substates.unshift(substate)
            this.substateArray[atrI][j].unshift(substate);
            this.tilesContainer.addChild(sprite)
        }

        return {
            tiles: array,
            substates: substates,
        };
    }

    private async animLower(tiles, substates) {
        clearTimeout(this.hintTimer);
        this.scaleMoves(false);
        if (this.isGameEnd) {
            return;
        }

        this.scaleMoves(false)
        // this.interactive = false;
        let isAnimEnd = false;
        let isNeedToDelete = false;
        await new Promise((res, rej) => {
            SoundService.toggleMatch(true, 1);
            for (let i = 0; i < tiles.length; i++) {

                // if (tiles[i].type !== 0) {
                //     tiles[i].alpha = 0;
                // }
                const tileY = tiles[i].y + LevelObject.tileHeight * tiles[i].shift;
                const substateY = substates[i].y + LevelObject.tileHeight * tiles[i].shift;
                gsap.to([tiles[i], substates[i]], {
                    y: tileY, duration: 0.7,
                    ease: 'bounce',
                    onComplete: () => {
                        tiles[i].y = tileY;
                        substates[i].y = substateY;
                        const array = this.concatedMatrix;
                        const nextTile = array[tiles[i].row + 1];
                        tiles[i].y = tileY;
                        substates[i].y = substateY;
                        if (tiles[i].type === 0 && tiles[i].isLast
                            && (!nextTile || nextTile[tiles[i].col] === 0)) {
                            isNeedToDelete = true;
                            this.productCounter += 1;
                            CounterStorage.counter.text = `${this.productCounter}/${this.productLength}`
                            this.destroyProduct(tiles[i])

                        }
                        tiles[i].shift = 0;
                        if (i === tiles.length - 1) {
                            res(null);
                        }
                    },
                    onUpdate: () => {
                        const map = tiles[i].mapNum;
                        let row = tiles[i].row;
                        const col = tiles[i].col;
                        const startY = this.startForSpawn[map][col];
                        tiles[i].renderable = true;
                        if (row >= 7) {
                            tiles[i].row = 6;
                            row = 6;
                        }

                        if (row <= -1) {
                            tiles[i].row = 0;
                            row = 0;
                        }
                        if (this.booleanMatrix[row][col] === 0) {
                            // tiles[i].alpha = 0;
                            // tiles[i].isHidden = true;
                        } else {
                            if (tiles[i].y >= startY - tiles[i].height && tiles[i].type !== 0 && tiles[i].alpha === 0) {
                                substates[i].alpha = 1;
                                tiles[i].alpha = 1;
                                tiles[i].isHidden = false;
                            }
                        }
                    }
                })
            }
        })

        if (!isAnimEnd && !isNeedToDelete) {
            isAnimEnd = true;
            setTimeout(() => {
                this.findMoves(false);
                this.getAllChains(false, true, true);
            }, 200)
        }
    }

    private async destroyProduct(tile): Promise<void> {
        const map = tile.mapNum;
        let row = tile.row;
        const col = tile.col;
        const tiles = LevelObject.tiles;
        new Promise((res, rej) => {
            for (let i = tiles[map][col].length - 1; i >= 0; i--) {
                const tile = tiles[map][col][i];
                const substate = this.substateArray[map][col][i]
                if (tile.type === 0) {
                    LevelObject.animations[tile.col][tile.row].alpha = 1;
                    LevelObject.animations[tile.col][tile.row].gotoAndPlay(0);
                    tile.visible = false;
                    substate.visible = false;
                    tile.type = -1;
                }

                if (i === 0) {
                    res(null);
                }
            }
        })

        await setTimeout(() => {
            this.getAllChains(false, true, true, true);
        }, 400)
    }

    protected swap(x1, y1, x2, y2) {
        const array = this.getConcatedMatrix();


        const tile1 = array[x1][y1];
        const tile2 = array[x2][y2];

        if (tile1 === 0 || tile2 === 0 || tile1.type === 0 || tile2.type === 0) {
            return false;
        }
        let typeSwap = array[x1][y1].type;
        array[x1][y1].type = array[x2][y2].type;
        array[x2][y2].type = typeSwap;
        return true


        //         const tile1 = array[x1][y1];
        //         const tile2 = array[x2][y2];

        //         if (tile1 === 0 || tile2 === 0) {
        //             return false;
        //         }

        //         let typeSwap = array[x1][y1].type;
        //         array[x1][y1].type = array[x2][y2].type;
        //         array[x2][y2].type = typeSwap;
        //         return true
    }

    // private swap(x1, y1, x2, y2, map) {
    //     const tile1 = LevelObject.tiles[map][x1][y1];
    //     const tile2 = LevelObject.tiles[map][x2][y2];

    //     if (tile1.isHidden || tile2.isHidden || tile1.type === 0 || tile2.type === 0) {
    //         return;
    //     }

    //     const typeSwap = LevelObject.tiles[map][x1][y1].type;
    //     tile1.type = LevelObject.tiles[map][x2][y2].type;
    //     tile2.type = typeSwap;
    // }

    protected async findMoves(state) {
        const moves = [];
        // Check horizontal swaps
        this.moves = [];
        let clusters;
        let tiles = this.getConcatedMatrix();

        for (let i = 0; i < tiles.length - 1; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                let isRare = false;
                const isSwap = this.swap(i, j, i + 1, j);
                if (isSwap) {
                    this.findClusters(false);
                    this.swap(i, j, i + 1, j);
                }

                if (this.clusters && this.clusters.length > 0) {
                    const tile = tiles[i][j];
                    // Found a move
                    this.moves.push({
                        column1: i, row1: j,
                        column2: i + 1, row2: j,
                        tile1: tile, tile2: tiles[i + 1][j],
                    });
                }

                if (this.moves.length > 0) {
                    break;
                }
            }

            if (this.moves.length > 0) {

                break;
            }
        }

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length - 1; j++) {
                let isRare = false;
                const isSwap = this.swap(i, j, i, j + 1);
                if (isSwap) {
                    this.findClusters(false);
                    this.swap(i, j, i, j + 1);
                }

                if (this.clusters && this.clusters.length > 0) {
                    const tile = tiles[i][j];
                    // Found a move
                    this.moves.push({
                        column1: i, row1: j,
                        column2: i, row2: j + 1,
                        tile1: tile, tile2: tiles[i][j + 1],
                    });

                }

                if (this.moves.length > 0) {
                    break;
                }
            }

            if (this.moves.length > 0) {
                break;
            }
        }

        this.clusters = [];
        if (state) {
            if (this.moves.length === 0) {
                this.mixTiles(true);
            } else {
                clearTimeout(this.hintTimer);
                this.hintTimer = setTimeout(() => {
                    this.scaleMoves(true, 0);
                }, 7000)
            }
        }
        // // Reset moves
        // this.moves = []
        // const tiles = LevelObject.tiles;
        // // Check horizontal swaps

        // let array = this.concatedMatrix;
        // new Promise((res, rej) => {
        //     for (let i = 0; i < array.length - 1; i++) {
        //         for (let j = 0; j < array[i].length; j++) {
        //             const isSwap = this.swap(i, j, i + 1, j);
        //             if (isSwap) {
        //                 this.findClusters(false);
        //                 this.swap(i, j, i + 1, j);
        //             }

        //             if (this.clusters.length > 0) {
        //                 const tile = array[i][j];
        //                 // Found a move
        //                 this.moves.push({
        //                     column1: i, row1: j,
        //                     column2: i + 1, row2: j,
        //                     tile1: tile, tile2: array[i + 1][j]
        //                 });
        //             }
        //         }
        //     }

        //     for (let i = 0; i < array.length; i++) {
        //         for (let j = 0; j < array[i].length - 1; j++) {
        //             const isSwap = this.swap(i, j, i, j + 1);
        //             if (isSwap) {
        //                 this.findClusters(false);
        //                 this.swap(i, j, i, j + 1);
        //             }

        //             if (this.clusters.length > 0) {
        //                 const tile = array[i][j];
        //                 // Found a move
        //                 this.moves.push({
        //                     column1: i, row1: j,
        //                     column2: i, row2: j + 1,
        //                     tile1: tile, tile2: array[i][j + 1]
        //                 });
        //             }

        //             if (i === array.length - 1 && j === array[i].length - 2) {
        //                 res();
        //             }
        //         }
        //     }
        // })
        // // Reset clusters
        // this.clusters = [];
        // if (state) {
        //     if (this.moves.length === 0) {
        //         this.mixTiles(true);
        //     } else {
        //         clearTimeout(this.hintTimer);
        //         this.hintTimer = setTimeout(() => {
        //             this.scaleMoves(true, 0);
        //         }, 7000)
        //     }
        // }
    }

    private scaleMoves(state, num?): void {
        const moves = this.moves;
        const duration = 0.8;

        if (state && moves.length > num) {
            const tile1 = moves[num].tile1;
            const tile2 = moves[num].tile2;

            if (tile1 && tile2 && tile1.type !== 0 && tile2.type !== 0) {
                gsap.to(tile1.scale, { x: 0.53, y: 0.53, repeat: 3, yoyo: true, duration: duration })
                gsap.to(tile2.scale, { x: 0.53, y: 0.53, repeat: 3, yoyo: true, duration: duration })
            } else {
                this.moves.splice(num, 1);
            }

            this.tileHintTimer = setTimeout(() => {

                if (num + 1 === moves.length) {
                    num = -1;
                }

                this.scaleMoves(true, num + 1)
            }, (duration * 5.5) * 1250);
        }

        if (!state && moves) {
            clearTimeout(this.hintTimer);
            clearTimeout(this.tileHintTimer);
            for (let i = 0; i < moves.length; i++) {
                if (moves[i].tile1 && !moves[i].tile1._destroyed && moves[i].tile1.type !== 0) {
                    gsap.killTweensOf(moves[i].tile1.scale)
                    moves[i].tile1.scale.set(moves[i].tile1.originScale.x, moves[i].tile1.originScale.y)
                }

                if (moves[i].tile2 && !moves[i].tile2._destroyed && moves[i].tile2.type !== 0) {
                    gsap.killTweensOf(moves[i].tile2.scale)
                    moves[i].tile2.scale.set(moves[i].tile2.originScale.x, moves[i].tile2.originScale.y)
                }
            }
        }
    }

    public mixTiles(state) {
        const tiles = LevelObject.tiles;
        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = 0; d < tiles[i][j].length; d++) {
                    if (tiles[i][j][d].type !== 0) {
                        const newTile = TilesHelper.getNewTexture(LevelsConfig.levels[this.level.num].drop_chance);
                        LevelObject.tiles[i][j][d].texture = newTile.texture;
                        LevelObject.tiles[i][j][d].type = newTile.type;
                    }
                }
            }
        }

        this.findClusters();

        if (this.clusters.length > 0) {
            this.mixTiles(state);
        } else {
            this.findMoves(state);
        }
        this.interactive = true;
    };

    private getHorizontalChains(grid, row: number, isNeedToRemove: boolean = true): any[] {
        let result: any[] = [];
        let horizontal: any[];
        let piece;
        let pieceBefore;
        let col: number;
        pieceBefore = grid[0][row];
        horizontal = [];
        horizontal.push(pieceBefore);
        for (col = 1; col < grid.length; col++) {
            piece = grid[col][row];
            if (piece !== 0 && pieceBefore !== 0
                && piece.type === pieceBefore.type && piece.type !== 0
                && piece.alpha !== 0 && pieceBefore.alpha !== 0
                && !piece.isHidden && !pieceBefore.isHidden) {
                horizontal.push(piece);
            } else {
                if (horizontal.length >= 3) {
                    result = result.concat(horizontal);
                }
                horizontal = [];
                horizontal.push(piece);
            }

            pieceBefore = piece;
        }
        if (horizontal.length >= 3) {
            result = result.concat(horizontal);
        }

        return result;
    }

    private getTile(j, d) {
        const matrixes = LevelObject.tiles;
        let activeTile = null;
        for (let i = 0; i < matrixes.length; i++) {
            const matrix = matrixes[i];
            const tile = matrix[d][j];
            if (tile.alpha !== 0) {
                activeTile = tile;
                break;
            }
        }

        return activeTile;
    }

    private getVerticalChains(grid, col: number, isNeedToRemove: boolean = true): any[] {
        let result: any[] = [];
        let vertical: any[];
        let piece;
        let pieceBefore;
        let row: number;

        pieceBefore = grid[col][0];

        vertical = [];
        vertical.push(pieceBefore);

        for (row = 1; row < grid.length; row++) {
            piece = grid[col][row];
            if (piece !== 0 && pieceBefore !== 0
                && piece.type === pieceBefore.type && piece.type !== 0
                && piece.alpha !== 0 && pieceBefore.alpha !== 0
                && !piece.isHidden && !pieceBefore.isHidden) {
                vertical.push(piece);
            } else {

                if (vertical.length >= 3) {
                    result = result.concat(vertical);
                }
                vertical = [];
                vertical.push(piece);
                if (vertical.length >= 3) {
                    result = result.concat(vertical);
                }
                vertical = [];
                vertical.push(piece);
            }

            pieceBefore = piece;
        }
        if (vertical.length >= 3) {
            result = result.concat(vertical);
        }

        return result;
    }

    public shuffle(): void {
        ShuffleService.shuffle(this.getConcatedMatrix(), this);
    }

    private changeScore(isAuto: boolean = true): void {
        if (this.isGameEnd) {
            return;
        }

        let clustersLength = this.clusters.length;
        if (clustersLength > 7) {
            clustersLength = 7;
        }
        this.score = ScoreConfig.scoreTabl[clustersLength][isAuto ? 'auto' : 'simple'].score;
        const progress = ScoreConfig.scoreTabl[clustersLength][isAuto ? 'auto' : 'simple'].progress;
        FillBarService.changeScore(this.score, this.productCounter, this.productLength, this.level.num, 0);
        this.score = 0;
    }

    private onMouseMove(e) {
        if (this.drag && LevelObject.selectedTile.selected) {
            var pos = this.getMousePos(this, e);
            // Reset dragging
            let mt = this.getMouseTile(pos);
            if (mt.valid) {
                let tile;
                const tiles = LevelObject.tiles;
                for (let i = 0; i < tiles.length; i++) {
                    const tl = tiles[i][mt.x][mt.y];
                    if (tl.alpha === 1) {
                        tile = tl;
                    }
                }
                if (tile && this.canSwap(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row)
                    && tile.alpha !== 0 && tile.type !== 0) {
                    this.interactive = false;
                    // Tiles can be swapped, swap the tiles
                    this.swapTiles(mt.x, mt.y, LevelObject.selectedTile.column,
                        LevelObject.selectedTile.row, LevelObject.selectedTile.map, tile.mapNum);
                }
            }
        }
    }

    private onMouseDown(e) {
        this.scaleMoves(false)
        this.drag = false;
        // Get the mouse position
        const pos = this.getMousePos(this, e);

        // Start dragging
        if (!this.drag) {
            // Get the tile under the mouse
            let mt = this.getMouseTile(pos);
            let tile;
            const tiles = LevelObject.tiles;
            for (let i = 0; i < tiles.length; i++) {
                const tl = tiles[i][mt.x][mt.y];
                if (tl.alpha === 1) {
                    tile = tl;
                }
            }

            if (tile && mt.valid && tile.type !== 0 && tile.alpha !== 0) {
                // Valid tile
                tile.scale.set(0.53);
                LevelObject.selectedTile.map = tile.mapNum;
                LevelObject.selectedTile.column = mt.x;
                LevelObject.selectedTile.row = mt.y;
                LevelObject.selectedTile.tile = tile;
                LevelObject.selectedTile.selected = true;
            } else {
                // Invalid tile
                LevelObject.selectedTile.selected = false;
            }
            this.drag = true;
        }
    }

    protected onMouseUp(e) {

        var pos = this.getMousePos(this, e);
        // Reset dragging
        let mt = this.getMouseTile(pos);
        if (mt.valid) {
            let tile;
            const tiles = LevelObject.tiles;
            for (let i = 0; i < tiles.length; i++) {
                const tl = tiles[i][mt.x][mt.y];
                if (tl.alpha === 1) {
                    tile = tl;
                }
            }
            // if (tile && this.canSwap(mt.x, mt.y, LevelObject.selectedTile.column, LevelObject.selectedTile.row)
            //     && tile.alpha !== 0 && tile.type !== 0) {
            //     // Tiles can be swapped, swap the tiles
            //     this.swapTiles(mt.x, mt.y, LevelObject.selectedTile.column,
            //         LevelObject.selectedTile.row, LevelObject.selectedTile.map, tile.mapNum);
            // }
        }
        if (LevelObject.selectedTile.selected) {
            let selectedTile = LevelObject.tiles[LevelObject.selectedTile.map][LevelObject.selectedTile.column][LevelObject.selectedTile.row];
            if (selectedTile.type !== 0) {
                selectedTile.scale.set(selectedTile.originScale.x, selectedTile.originScale.y);
            }
            // selectedTile.alpha = 1;
            LevelObject.selectedTile = { selected: false, map: null, column: 0, row: 0, tile: null };
        }

        this.drag = false;
    }

    protected canSwap(x1, y1, x2, y2) {
        // Check if the tile is a direct neighbor of the selected tile
        if ((Math.abs(x1 - x2) === 1 && y1 === y2) ||
            (Math.abs(y1 - y2) === 1 && x1 === x2)) {
            return true;
        }

        return false;
    }

    protected getMousePos(canvas, e) {
        const rect = canvas.getBounds();
        return {
            x: Math.round((e.data.global.x - rect.left) / (rect.right - rect.left) * canvas.width),
            y: Math.round((e.data.global.y - rect.top) / (rect.bottom - rect.top) * canvas.height)
        };
    }

    protected async swapTiles(c1, r1, c2, r2, map2, map1) {
        // Save the current move
        // this.currentMove = {column1: c1, row1: r1, column2: c2, row2: r2};
        const currentMove = { column1: c1, row1: r1, column2: c2, row2: r2 };
        // Deselect
        let selectedTile = LevelObject.tiles[LevelObject.selectedTile.map][LevelObject.selectedTile.column][LevelObject.selectedTile.row];
        if (selectedTile.type !== 0) {
            selectedTile.scale.set(selectedTile.originScale.x, selectedTile.originScale.y);
        }
        // selectedTile.alpha = 1;
        LevelObject.selectedTile.map = null;
        LevelObject.selectedTile.column = null;
        LevelObject.selectedTile.row = null;
        LevelObject.selectedTile.selected = false;
        const coord1 = this.getCoordinateTile(currentMove.column1, currentMove.row1);
        const coord2 = this.getCoordinateTile(currentMove.column2, currentMove.row2);

        const tile1 = LevelObject.tiles[map1][c1][r1];
        const tile2 = LevelObject.tiles[map2][c2][r2];
        const newData = {
            tile1: {
                col: tile2.col,
                row: tile2.row,
                mapNum: tile2.mapNum
            },
            tile2: {
                col: tile1.col,
                row: tile1.row,
                mapNum: tile1.mapNum
            }
        }

        if (tile2.type !== 0) {
            tile2.scale.set(tile2.originScale.x, tile2.originScale.y);
        }

        TweenMax.to(tile1, .3, {
            x: coord2.tileX,
            y: coord2.tileY
        });

        gsap.to(tile2, .3, {
            x: coord1.tileX,
            y: coord1.tileY,
            onComplete: () => {
                LevelObject.tiles[map1][c1][r1].col = newData.tile1.col;
                LevelObject.tiles[map1][c2][r2].col = newData.tile2.col;
                LevelObject.tiles[map2][c1][r1].row = newData.tile1.row;
                LevelObject.tiles[map2][c2][r2].row = newData.tile2.row;
                LevelObject.tiles[map1][c1][r1].mapNum = newData.tile1.mapNum;
                LevelObject.tiles[map2][c2][r2].mapNum = newData.tile2.mapNum;
                [LevelObject.tiles[map1][c1][r1], LevelObject.tiles[map2][c2][r2]] = [LevelObject.tiles[map2][c2][r2], LevelObject.tiles[map1][c1][r1]];
                this.getAllChains(false, false, true, false, true).then(async (res) => {
                    if (res) {
                    } else {
                        LevelObject.tiles[map1][c1][r1].col = newData.tile1.col;
                        LevelObject.tiles[map1][c2][r2].col = newData.tile2.col;
                        LevelObject.tiles[map2][c1][r1].row = newData.tile1.row;
                        LevelObject.tiles[map2][c2][r2].row = newData.tile2.row;
                        LevelObject.tiles[map1][c1][r1].mapNum = newData.tile1.mapNum;
                        LevelObject.tiles[map2][c2][r2].mapNum = newData.tile2.mapNum;
                        [LevelObject.tiles[map1][c1][r1], LevelObject.tiles[map2][c2][r2]] = [LevelObject.tiles[map2][c2][r2], LevelObject.tiles[map1][c1][r1]];
                        gsap.to(tile1, .3, {
                            x: coord1.tileX,
                            y: coord1.tileY,
                            onComplete: () => {
                                this.interactive = true;
                            }
                        });

                        gsap.to(tile2, .3, {
                            x: coord2.tileX,
                            y: coord2.tileY
                        });
                    }
                })
            }
        });
    }

    protected getMouseTile(pos) {
        // Calculate the index of the tile
        const tx = Math.floor((pos.x) / (LevelObject.tileWidth));
        const ty = Math.floor((pos.y) / (LevelObject.tileHeight));
        // var tx = Math.floor((pos.x - LevelObject.x) / LevelObject.tileWidth);
        // var ty = Math.floor((pos.y - LevelObject.y) / LevelObject.tileHeight);

        // Check if the tile is valid
        if (tx >= 0 && tx < LevelObject.columns && ty >= 0 && ty < LevelObject.rows) {
            // Tile is valid
            return {
                valid: true,
                x: tx,
                y: ty
            };
        }
        // const tiles = LevelObject.tiles;
        // for (let i = 0; i < tiles.length; i++) {
        //     for (let j = 0; j < tiles[i].length; j++) {
        //         if (tx >= 0 && tx < tiles[i][j].length && ty >= 0 && ty < tiles[i].length) {
        //             // Tile is valid
        //             return {
        //                 valid: true,
        //                 map: i,
        //                 x: tx,
        //                 y: ty
        //             };
        //         }
        //     }
        // }

        // No valid tile
        return {
            valid: false,
            map: 0,
            x: 0,
            y: 0
        };
    }

    private sortContainerChildren(container): void {
        container.children.sort((a, b) => {
            return a.zIndex - b.zIndex;
        });
    }
}